export default __webpack_public_path__ + "static/media/takingpicportrait.3dc72285.jpg";